module.exports = __webpack_public_path__ + "static/media/Flock Final Logo.ec561fde.png";